import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative w-full h-[520px] md:h-[680px] overflow-hidden" aria-labelledby="hero-title">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20actress%20silhouette%20with%20soft%20golden%20evening%20light%2C%20dreamy%20atmospheric%20scene%2C%20cherry%20blossom%20petals%20floating%20in%20air%2C%20warm%20cream%20and%20rose%20gold%20tones%2C%20cinematic%20composition%2C%20artistic%20photography%20with%20soft%20focus%2C%20elegant%20and%20romantic%20mood&width=1600&height=900&seq=hero-bg-2026&orientation=landscape"
          alt="佐佐木明希 - 官方粉丝站"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full h-full flex flex-col items-center justify-center text-center px-4 md:px-6">
        <p className="text-background-50/70 text-sm md:text-base mb-3 tracking-widest animate-fade-in-up">
          官方粉丝落地页
        </p>
        <h1 id="hero-title" className="font-heading text-4xl md:text-6xl lg:text-7xl text-background-50 mb-5 animate-fade-in-up" style={{ animationDelay: '0.1s' }}>
          佐佐木明希
        </h1>
        <p className="text-background-50/80 text-base md:text-lg max-w-2xl leading-relaxed mb-8 animate-fade-in-up" style={{ animationDelay: '0.2s' }}>
          汇聚最新动态、个人资料、作品精选与粉丝社区<br className="hidden sm:block" />带你全面了解佐佐木明希的魅力世界
        </p>
        <div className="flex flex-col sm:flex-row items-center gap-3 animate-fade-in-up" style={{ animationDelay: '0.3s' }}>
          <Link
            to="/category/news"
            className="px-8 py-3 rounded-full bg-primary-500 text-background-50 font-medium text-sm hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            探索最新动态
          </Link>
          <Link
            to="/about"
            className="px-8 py-3 rounded-full bg-background-50/15 text-background-50 font-medium text-sm hover:bg-background-50/25 backdrop-blur-sm transition-all duration-300 whitespace-nowrap cursor-pointer"
          >
            了解更多
          </Link>
        </div>
      </div>

      <style>{`
        @keyframes fade-in-up {
          from { opacity: 0; transform: translateY(24px); }
          to { opacity: 1; transform: translateY(0); }
        }
        .animate-fade-in-up {
          animation: fade-in-up 0.8s cubic-bezier(0.16, 1, 0.3, 1) forwards;
          opacity: 0;
        }
      `}</style>
    </section>
  );
}